/* eslint-disable @next/next/no-before-interactive-script-outside-document */
import React, { useEffect } from 'react'
import 'focus-visible'
import 'styles/global.css'
import { AuthProvider } from 'util/auth'
import { QueryClientProvider } from 'util/db'
import analytics from 'util/analytics'
import '@fortawesome/fontawesome-svg-core/styles.css'
// Prevent fontawesome from adding its CSS since we did it manually above:
import { config } from '@fortawesome/fontawesome-svg-core'
import Script from 'next/script'
import ErrorBoundary from 'boundaries/ErrorBoundary'
import { Toaster } from 'react-hot-toast'
import { UploadManager } from 'components/UploadManager'
import { ActiveUploads } from 'components/ActiveUploads'
import { useRouter } from 'next/router'
import { trackPageView } from 'util/fbPixel'
config.autoAddCss = false /* eslint-disable import/first */
import { Roboto, Plus_Jakarta_Sans } from 'next/font/google'

const SCRIPT_URL = 'https://r.wdfl.co/rw.js'
const API_KEY = '84d40d'

const openSans = Roboto({
  subsets: ['latin'],
  weight: ['400', '500', '700'],
  variable: '--font-open-sans',
})

const jakarta = Plus_Jakarta_Sans({
  subsets: ['latin'],
  weight: ['400', '500', '700', '800'],
  variable: '--font-jakarta',
})

function MyApp({ Component, pageProps }) {
  const router = useRouter()

  useEffect(() => {
    analytics.page()

    // Handle route change events for Facebook Pixel
    const handleRouteChange = () => {
      trackPageView()
    }

    // Initial page load
    handleRouteChange()

    // Subscribe to router events
    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  return (
    <main className={`${openSans.variable} ${jakarta.variable}`}>
      <style jsx global>{`
        html {
          font-family: ${openSans.style.fontFamily};
        }
      `}</style>
      <ErrorBoundary>
        <QueryClientProvider>
          <AuthProvider>
            <UploadManager />
            <ActiveUploads />
            <Component {...pageProps} />
          </AuthProvider>
        </QueryClientProvider>
        <Toaster
          containerStyle={{
            fontSize: '14px',
          }}
          toastOptions={{
            duration: 5000,
            className: '!bg-slate-800 !text-white',
          }}
          position="top-right"
        />
      </ErrorBoundary>
      <Script
        data-domains="outcast.ai, app.outcast.ai"
        src={SCRIPT_URL}
        data-rewardful={API_KEY}
      ></Script>
      <Script id="rewardful-queue" strategy="beforeInteractive">
        {`(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful');`}
      </Script>
      <Script id="rewardful-ready" strategy="afterInteractive">
        {`rewardful('ready', function() {
    if(Rewardful.referral) {
      // The current website visitor is a referral from an affiliate.
      console.log('Referral detected:', Rewardful.referral);
    } else {
      // The current website visitor is not a referral from an affiliate.
      console.log('No referral detected.');
    }
  });`}
      </Script>
    </main>
  )
}

export default MyApp
